<template>
  <v-container fluid >
    <v-row justify="center" >
      <v-card
        tile
        style="border-radius: 25px 25px 0 0; pr-0"
        width="540px"
        :class="isDisc ? 'height_97' : 'height_77'"
      >
        <v-container
          class="fluid"
          :style="bcgColor"
          style=" height:70px !important;width:100%;"
        >
          <v-row
            style="width:100%;"
            justify="end"
            align="center"
            light
          >
            <v-btn icon @click="cancelClick">
              <CloseIcon style="fill:#0247A7" />
            </v-btn>
          </v-row>
        </v-container>
        <v-container
          class="fluid pr-2 pl-6"
          :style="bdyColor"
          style=" width:100%"
          id="modalContainer"
        >
          <v-row
            style="width:102.5%"
            align="center"
            justify="center"
          >
            <span :style="titleProps">{{ titleText }}</span>
          </v-row>
          <v-row
            style="width:102.5%"
            align="center"
            justify="center"
          >
            <v-col>
              <p :style="msgProps" class="ft_depend_height" :class="isDisc ? 'mt-4' : ''">{{ msgText }}</p>
            </v-col>
          </v-row>

          <v-row style=" width:10%" v-if="!isDisc"> </v-row>

          <v-row
            style="width:102.5%"
            align="center"
            justify="center"
            v-if="!isDisc"
            class="height_45"
          >
            <v-col class="d-flex justify-center" v-if="!checkRendered" cols="12">
              <v-col style="max-width: 145px !important;margin-top:5%"   class="px-0 py-0" >
                <v-progress-linear
                  color="blue-grey lighten-3"
                  indeterminate
                  rounded
                  height="2"
                ></v-progress-linear>
              </v-col>
            </v-col>
            <v-col cols="12" class="d-flex justify-center py-0">
              <v-col cols="6" class="py-0">
                <component v-bind:is="currentTabComponent"></component>
              </v-col>
            </v-col>



          </v-row>

<!--          <v-row style="height: 5%; width:10%" v-if="isDisc"> </v-row>-->

          <v-row
            style="width:100%"
            align="end"
            justify="center"
            v-if="!isDisc"
          >
           <v-col cols="12" class="d-flex justify-center py-0">
             <v-col cols="8" class="d-flex justify-center py-0">
               <v-btn
                 :style="buttonProps"
                 outlined
                 :key="widgetKey"
                 @click.once="submitClick"
                 class="btn_height_50"
               >
              <span :style="btnTextProps">
                {{ buttonText }}
              </span>
               </v-btn>
             </v-col>
           </v-col>

          </v-row>
<!--          <v-row style="height: 5%; width:10%" v-if="isDisc"> </v-row>-->

          <v-row
            style="width:95%; border: 1px solid #C9CACB; margin-left:1%"
            class="pa-0 my-0"
            v-if="isDisc"
          >
            <v-col cols="3" class="ma-0 pa-0" style="height:100%;width:100%">
              <v-img
                :src="discImgSrc"
                class="ma-0 pa-0"
                height="100%"
                width="100%"
                style="background:#4E5D6B"
              >
              </v-img>
            </v-col>
            <v-col cols="9" class="fl_direction px-0 py-0"  v-if="checkOptin">
              <v-row style="width:100%;padding-left:12px;">
                <span style="font-weight:bold;font-size:120%; color:#5686F6">
                  {{ dscntCd }}
                </span>
              </v-row>

              <v-row
                style="width:100%;padding-left:12px;"
                align="center"
              >
                <span>
                  {{ dscntInstr }}
                </span>
              </v-row>
              <v-row style="width:100%; padding-left:12px;" align="start">
                <v-btn
                  :style="buttonProps"
                  outlined
                  v-clipboard:copy="dscntCd"
                  v-clipboard:success="cpySuccess"
                >
                  <span :style="btnTextProps">
                    {{ cpyBtnTxt }}
                  </span>
                </v-btn>
              </v-row>
            </v-col>
            <v-col cols="9" class="fl_direction px-0 py-0"  v-if="!checkOptin">
              <v-row
                style="width:100%; padding-left:12px; padding-right:10px"
              >
                <span style="font-weight:bold; font-size:82%;text-align: start !important;" :style="msgProps" class="ml-2">
                  {{ dscntStmt }}
                </span>
              </v-row>
              <v-row style="width:100%;" class="mt-2">
                <v-col
                  style="width:100%; "
                  class="height_35"
                >
                  <v-col class="py-0 d-flex justify-center" v-if="!checkRendered">
                    <v-col
                      class=" py-0 mt-6 "
                      style="max-width:145px;"
                      cols="12"
                    >
                      <v-progress-linear
                        color="blue-grey lighten-3"
                        indeterminate
                        rounded
                        height="2"
                      ></v-progress-linear>
                    </v-col>
                  </v-col>
                  <v-col class="px-0 py-0 d-flex justify-end" style="height: 65px !important;">

                      <component v-bind:is="currentTabComponent" style="height: 65px !important;"></component>

                  </v-col>
                </v-col>
              </v-row>
              <v-row style="width:100%; padding-left:10px;" align="start" class="mt-2">
                <v-col class="py-0">
                  <v-col
                    class="px-0 py-0"
                    cols="12"
                  >
                    <v-btn
                      :style="buttonProps"
                      outlined
                      :key="widgetKey"
                      @click.once="submitClick"
                      class="width_100"
                    >
                      <span :style="btnTextProps">
                        {{ buttonText }}
                      </span>
                    </v-btn>
                  </v-col>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row
            style="width:102.5%"
            class="mt-5"
            align="center"
            justify="center"
            v-if="!retCpyDone"
          >
            <a :style="cancelProps" @click="cancelClick">{{ cancelText }}</a>
          </v-row>

          <v-row
            style="width:102.5%"
            class="mt-5"
            align="center"
            justify="center"
            v-if="retCpyDone"
          >
            <a :style="cancelProps" @click="cancelClick">Close</a>
          </v-row>
        </v-container>
      </v-card>
    </v-row>
    <!-- <v-alert light v-if="retCpyDone" style="margin-top:5%;" dense text outlined>
      Discount Code Copied Successfully
    </v-alert> -->
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import MessengerCheckbox from "./MessengerCheckbox.vue";
import DummyDiv from "./DummyDiv.vue";
import Vue from "vue";
import CloseIcon from "@/assets/icons/close.svg";

export default {
  name: "WidgetViewCheckBox",
  components: { MessengerCheckbox, DummyDiv, CloseIcon },
  data() {
    return {
      dialog: false,
      btnId: 0,
      didOptIn: false,
      cpyDone: false,

    };
  },
  methods: {
    incrBtnId() {
      this.btnId++;
    },
    toggleDialog() {
      this.dialog = !this.dialog;
    },
    resetChanges() {
      this.$store.dispatch("getWidgets");
    },
    cancelClick() {
      this.$store.dispatch("toggleDisplay");
    },
    submitClick() {
      if (this.$store.getters.getCheckBoxState == "checked") {
        this.$store.dispatch("toggleDisplay");
        Vue.FB.AppEvents.logEvent("MessengerCheckboxUserConfirmation", null, {
          app_id: this.getMessengerId,
          page_id: this.getFbPgId,
          ref: this.$store.getters.getInstanceId,
          user_ref: this.$store.getters.getCheckBoxUserRef,
        });
      } else {
        this.$store.dispatch("setErrFlashFB", true).then(() => {
          this.incrBtnId();
          setTimeout(() => {
            this.$store.dispatch("setErrFlashFB", false);
          }, 1000);
        });
      }
    },
    cpySuccess() {
      this.cpyDone = true;
      setTimeout(() => {
        this.cpyDone = false;
      }, 1500);
    },
  },
  computed: {
    ...mapGetters(["getWidgetsState", "getFbDetails", "getCheckBoxRendered"]),

    discImgSrc() {
      return `${process.env.VUE_APP_CLOUD_STORAGE_URL}/widget/img/discount-icon.png`;
    },

    cpyBtnTxt() {
      if (this.cpyDone) {
        return "COPIED!";
      } else {
        return "COPY DISCOUNT CODE";
      }
    },
    retCpyDone() {
      return this.cpyDone;
    },
    getMessengerId() {
      return this.getFbDetails.messenger_app_id;
    },
    getFbPgId() {
      return this.getFbDetails.page_id;
    },
    detectChange() {
      return this.getWidgetsState.changesSaved;
    },
    currentTabComponent() {
      if (this.getFbDetails.div_class == "fb-send-to-messenger") {
        return "MessengerCheckbox";
      } else {
        return "DummyDiv";
      }
    },
    bcgColor() {
      let hdrClsObj = {
        "background-color": this.getWidgetsState.header_background_color,
      };
      return hdrClsObj;
    },
    bdyColor() {
      let bdyClsObj = {
        "background-color": this.getWidgetsState.popup_background_color,
      };
      return bdyClsObj;
    },
    titleText() {
      return this.getWidgetsState.pop_up_title;
    },
    titleProps() {
      let ttlObj = {
        color: this.getWidgetsState.pop_up_title_font_color,
        "font-weight": this.getWidgetsState.pop_up_title_font_type,
        "font-size": this.getWidgetsState.pop_up_title_font_size + "px",
        "font-family": this.getWidgetsState.pop_up_title_font_family,
      };
      return ttlObj;
    },
    msgText() {
      return this.getWidgetsState.pop_up_message;
    },
    msgProps() {
      let ttlObj = {
        color: this.getWidgetsState.pop_up_message_font_color,
        "font-weight": this.getWidgetsState.pop_up_message_font_type,
        "font-size": this.getWidgetsState.pop_up_message_font_size + "px",
        "font-family": this.getWidgetsState.pop_up_message_font_family,
        "text-align": "center",
      };
      return ttlObj;
    },
    cancelText() {
      return this.getWidgetsState.pop_up_cancel;
    },
    cancelProps() {
      let ttlObj = {
        color: this.getWidgetsState.pop_up_cancel_font_color,
        "font-weight": this.getWidgetsState.pop_up_cancel_font_type,
        "font-size": this.getWidgetsState.pop_up_cancel_font_size + "px",
        "font-family": this.getWidgetsState.pop_up_cancel_font_family,
        "text-decoration": "underline",
        "text-align": "center",
      };
      return ttlObj;
    },
    buttonText() {
      this.incrBtnId();

      return this.getWidgetsState.button_text;
    },
    buttonProps() {
      let borderRad =
        this.getWidgetsState.button_corners == "Round" ? "4px" : "0px";
      let buttonObj = {
        "background-color": this.getWidgetsState.button_background,
        "border-color": this.getWidgetsState.button_border_color,
        "border-radius": borderRad,
        "border-width": this.getWidgetsState.button_border_size + "px",
        width: "80%",
      };
      return buttonObj;
    },
    btnTextProps() {
      let btnObj = {
        color: this.getWidgetsState.button_font_color,
        "font-family": this.getWidgetsState.button_font_family,
        "font-weight": this.getWidgetsState.button_font_type,
        "font-size": this.getWidgetsState.button_font_size + "px",
        "text-transform": "none",
      };
      return btnObj;
    },
    widgetType() {
      return this.getWidgetsState.facebook_widget_type;
    },
    widgetKey() {
      return "key" + this.getWidgetsState.wdgt_key_internal + "b" + this.btnId;
    },
    checkRendered() {
      return this.getCheckBoxRendered;
    },
    isDisc() {
      return this.getWidgetsState.subscribe_type == "subscribe" ? true : false;
    },
    checkOptin() {
      return this.didOptIn;
    },
    dscntStmt() {
      return this.getWidgetsState.discount_statement;
    },
    dscntCd() {
      return this.getWidgetsState.discount_code;
    },
    dscntInstr() {
      return this.getWidgetsState.apply_discount_instruction;
    },
  },

  beforeCreate() {
    this.$store.dispatch("getWidgets");
  },
};
</script>

<style scoped>
.fb-btn {
  border-radius: 7px;
  text-transform: none;
}
.height_97{
  height: 80% !important;
}
</style>

<style lang="css">
.width_100{
  width: 100% !important;
}
.height_77{
  height: 100% !important;
}
.height_45{
  height: 90px !important;
}
.height_35{
  height: 70px !important;
}


</style>